export default __webpack_public_path__ + "static/media/circular_tunnel.7be565d2.png";